/**
 * Click handler to view more search results on the SearchWP live search tool
 */
function ldSearchResults(event) {
    // Find our live-search form to be submitted
    var formDesktop = jQuery('#livesearchform--desktop');
    // Find the input field inside the form
    var searchInputDesktop = formDesktop.find('#woocommerce-product-search-field');

    // Find our live-search form to be submitted
    var formMobile= jQuery('#livesearchform--mobile');
    // Find the input field inside the form
    var searchInputMobile = formMobile.find('#woocommerce-product-search-field');

    // If we find the desktop form and the search input is not empty, proceed
    if (formDesktop.length && searchInputDesktop.val().trim() !== '') {
        // Force a submit on the form
        formDesktop.submit();
    }

    // If we find the mobile form and the search input is not empty, proceed
    if (formMobile.length && searchInputMobile.val().trim() !== '') {
        // Force a submit on the form
        formMobile.submit();
    }
}

